import AppVariables from '../common/AppVariables';
import fileReaderStream from 'filereader-stream';
import concat from 'concat-stream';
import {MediaEndpoints} from './ProxyEndpoints';
import Jimp from 'jimp';

class MediaHelper{

    static async compressImageUploadAsync(buffer){
       return await Jimp.read(buffer).then(image => {
           return image.resize( Math.min( Math.max( image.getWidth() , 168 ) , 1024) , Jimp.AUTO )
               .getBufferAsync(image.getMIME())
       });
    }

    /**
     * Uploads profile image for supplied entity
     */
    static uploadProfileImage(file , id , role , media , done ){

        //  get global core-api proxy
        const proxy = window.proxy;

        //  is image
        if (!file.type.match('image.*')) {
            return alert('Selected file is not an image!');
        }

        if(file.size > AppVariables.MaxProfileImageSize){
            return alert('Image file too big!');
        }

        fileReaderStream(file).pipe(concat(async function (content) {

            content = await MediaHelper.compressImageUploadAsync(content);

            let endpoint;
            if (media && media.count > 0) {
                endpoint = MediaEndpoints.updateMedia(role, id, media.sources[0].tag , file, content);
            }
            else {
                endpoint = MediaEndpoints.createMedia(role, id, file, content, AppVariables.ProfileImageTag );
            }

            //  wait till done
            proxy.processRequest(endpoint).then((response) => {
                done(undefined, response.ok );
            }).catch((err) =>{
                done(err);
            });

        }));
    }

}

export default  MediaHelper;


// WEBPACK FOOTER //
// ./src/common/MediaHelper.js